module.exports = __webpack_public_path__ + "img/austria-respiratory-diseases-female.52fc7016.png";